"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectTypeTrackingEvents = void 0;
const trackingEventConstants_1 = require("./trackingEventConstants");
// READ THIS FIRST BEFORE ADDING THINGS HERE!!!
// We are capped by how many events we can have in Amplitude...so we want to
// keep this list short!
// Additonally its easier to browse these events in analytics tools
// if their are organized by surface or object type and NOT by action/feature/etc
exports.ObjectTypeTrackingEvents = {
    // SLOW DOWN BEFORE YOU ADD STUFF HERE...THINK HARD! DOES IT REALLY, REALLY BELONG HERE?
    // by object type
    assets: "assets",
    comments: "comments",
    organizations: trackingEventConstants_1.trackingEventOrganizations,
    users: "users",
    accounts: "accounts",
    projects: "projects",
    components: "components",
    parts: "parts",
    // SLOW DOWN BEFORE YOU ADD STUFF HERE...THINK HARD! DOES IT REALLY, REALLY BELONG HERE?
};
//# sourceMappingURL=ObjectTypeTrackingEvents.js.map